import { backendPy } from "System/system";
import store from "System/reduxStore";


// -------------------------------------------------------
// -------------------------------------------------------
export const calculateAdvanceData = cb => async (dispatch) => {
  const { id, datapath, calcParams, parameters } = store.getState().project;
  const advanceParams = calcParams?.advanceRate || {};
  await backendPy("advance", "calculate", {
    projectid: id,
    datapath,
    reference_date: parameters?.referenceDate || "",
    calcParamsString: JSON.stringify(advanceParams),
  });
  
  await dispatch(getAdvanceData( () => {}));
  cb();
};

// -------------------------------------------------------
// -------------------------------------------------------
export const getAdvanceData = (cb) => async (dispatch) => {
  const { id, datapath } = store.getState().project;
  const result = await backendPy("advance", "read", {
    projectid: id, datapath,
  });
  if(result.data) {
    dispatch({type: "SET_ADVANCE_DATA", advance: result.data});
  }
  cb();
};